/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
export const MEDIA_CONNECTOR_QUERY_KEYS = {
  all: ['media-connectors'] as const,
  list: () => [...MEDIA_CONNECTOR_QUERY_KEYS.all, 'list'] as const,
  platforms: () => [...MEDIA_CONNECTOR_QUERY_KEYS.all, 'platforms'] as const,
  syncStatus: () => [...MEDIA_CONNECTOR_QUERY_KEYS.all, 'sync-status'] as const,
  syncStatusByConnector: (connectorId: string) =>
    [...MEDIA_CONNECTOR_QUERY_KEYS.all, 'sync-status', connectorId] as const,
} as const;
